import React, { useEffect, useState } from 'react';

import './Fade.scss';
import classNames from 'classnames';

interface Props {
  show: boolean;
  className?: string;
}

export const Fade: React.FC<Props> = ({ show, children, className }) => {
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) setShouldRender(true);
  }, [show]);

  function onAnimationEnd() {
    if (!show) setShouldRender(false);
  }

  return (
    shouldRender && (
      <div
        className={classNames(className)}
        data-testid="FadeWrapper"
        style={{
          animation: `${show ? 'fadeIn' : 'fadeOut'} 2s`,
          position: 'absolute',
        }}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    )
  );
};

export default Fade;
